const ParseErrors = (error: any) => {
  if (
    error?.response?.data?.isLoggedIn === false &&
    error?.response.status === 419
  ) {
    window.location.pathname = "/auth";
  }

  if (error?.response?.data?.error?.errors?.length) {
    return error?.response?.data?.error?.errors[0]?.message;
  }

  if (error?.response?.data?.message) {
    return error?.response?.data?.message;
  }

  if (error?.response?.data?.errors?.length) {
    return error?.response?.data?.errors[0]?.msg;
  }

  if (!error?.response) {
    return "Unable to reach the server";
  }

  if (error?.response?.status >= 500) {
    return "The server is unavailable. Please try again.";
  }

  return "Unknown error";
};

export { ParseErrors };
